// extracted by mini-css-extract-plugin
export var orderDetails = "_s2-2";
export var orderImage = "_s2-1";
export var orderMeta = "_s2-3";
export var orderSummary = "_s2-0";
export var rightArrow = "_s2-4";